// extracted by mini-css-extract-plugin
export default {"modalContainer":"T0-z","modalIndicator":"U0-z","prevBtn":"V0-z","nextBtn":"W0-z","body":"X0-z","footer":"Y0-z"};